import React, { Fragment } from "react";
import { getApi } from '../../api/endpoints';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import ListingPageComponent from '../../components/ListingPageComponent';
import UiAction from "../../components/UiAction.js";
import UI_ACTIONS from "../../data/UiActionConstants.js";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

const Index = () => {
  const defaultHeaderConfig = { disableSort: false };
  const navigate = useNavigate();

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      label: 'Name',
      attr: 'name',
      disableSort: true
    },
    {
      label: 'Telematics Availble',
      attr: 'telematicsavailble?',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Weight',
      attr: 'weight',
    },
    {
      ...defaultHeaderConfig,
      label: 'Height',
      attr: 'height',
    },
    {
      ...defaultHeaderConfig,
      label: 'Length',
      attr: 'length',
    },
    {
      ...defaultHeaderConfig,
      label: 'Width',
      attr: 'width',
    },
    {
      ...defaultHeaderConfig,
      label: 'Capacity (AH)',
      attr: 'capacity_ah',
    },
    {
      ...defaultHeaderConfig,
      label: 'Capacity (Volt)',
      attr: 'capacity_volt',
    },
    {
      ...defaultHeaderConfig,
      label: 'Committed Swap Cycles',
      attr: 'committed_swap_cycles',
    },
    {
      label: 'Description',
      attr: 'description',
      disableSort: true
    },
    {
      disableSort: true,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.update_battery_model.name)}>
            <div style={{ cursor: 'pointer' }} onClick={(e) => onEditClick(row.id)}>
              <FontAwesomeIcon icon={faEdit} />
            </div>
          </UiAction>
        </div>
      }
    }
  ]

  const onEditClick = (id) => {
    navigate(`/battery_models/${id}/edit`);
  }

  const tableHeaderActionsComponent = () => {
    return <Fragment>
      <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.create_battery_model.name)}>
        <button className="s-btn me-2" style={{ width: "150px", fontSize: '11px' }} onClick={onNewClick}>
          <span>Add New Battery Model</span>
        </button>
      </UiAction>
    </Fragment>
  }

  const onNewClick = () => {
    navigate(`/battery_models/new`);
  }

  return <>
    <ListingPageComponent
      key={PAGES.BatteryModelsListingPage.name}
      uiPage={uiManager.getUiPage(PAGES.BatteryModelsListingPage.name)}
      breadcrumbs={[{ label: 'Home', url: '/dashboard' }, { label: 'Battery Models' }]}
      listingMutation={getApi('batteryModels')}
      className="battery-model-listing-page"
      contentHeading="All Battery Models - Results"
      headers={headers}
      recordsKey="battery_models"
      searchBy={['ID', 'Name']}
      tableHeaderActionsComponent={tableHeaderActionsComponent()}
    />
  </>
};

export default Index;
